export default __webpack_public_path__ + "static/media/redFlag.972773cd.png";